export const APA_ACHIEVEMENT_REQUEST = 'APA_ACHIEVEMENT_REQUEST';
export const APA_ACHIEVEMENT_SUCCESS = 'APA_ACHIEVEMENT_SUCCESS';
export const APA_ACHIEVEMENT_FAIL    = 'APA_ACHIEVEMENT_FAIL';

